export const diagnosticMenuDef = [
    {
        "name": "menu.vital_definition",
        "resource": "updateVitalDefinition",
        "icon": "fa fa-user-md",
        "url": "updateVitalDefinition",
        "auto_crud": true,
        "breadcrumb": "Folder Master",
        "check_permission": false,
        "showMenu": false
    },
    {
        "name": "menu.templateCosigner",
        "resource": "templateCosigner",
        "icon": "fa fa-plus-square",
        "url": "templateCosigner",
        "auto_crud": true,
        "showMenu": true,
        "check_permission": false
    },
    {
        "name": "menu.er_feedback",
        "resource": "field_definition",
        "icon": "fa fa-file-text-o",
        "url": "field_definition",
        "auto_crud": true,
        "breadcrumb": "Feed Back",
        "check_permission": false
    },
    {
        "name": "menu.bb_service_mapping",
        "resource": "bb_service_mapping",
        "icon": "fa fa-file-text-o",
        "url": "bb_service_mapping",
        "auto_crud": true,
        "permission_required": true,
        "breadcrumb": "Blood Request Service Item Mapping",
        "check_permission": false
    },
    {
        "name": "menu.service_request",
        "icon": "fa fa-plus-square",
        "data": {
            "nav_url": "diagnostic_m"
        },
        "children": [
            {
                "name": "menu.pathology_definition",
                "resource": "pathologyDefinition",
                "icon": "fa fa-file-text-o",
                "url": "pathologyDefinition",
                "auto_crud": true,
                "breadcrumb": "Pathology"
            },

            {
                "name": "menu.cardiology_definition",
                "resource": "cardiologyDefinition",
                "icon": "fa fa-file-text-o",
                "url": "cardiologyDefinition",
                "auto_crud": true,
                "breadcrumb": "Cardiology"
            },
            {
                "name": "menu.radiology_definition",
                "resource": "radiologyDefinition",
                "icon": "fa fa-file-text-o",
                "url": "radiologyDefinition",
                "auto_crud": true,
                "breadcrumb": "Radiology"
            },
            {
                "name": "menu.neurology_definition",
                "resource": "neurologyDefinition",
                "icon": "fa fa-file-text-o",
                "url": "neurologyDefinition",
                "auto_crud": true,
                "breadcrumb": "Neurology"
            },
            {
                "name": "menu.pulmonology_definition",
                "resource": "pulmonologyDefinition",
                "icon": "fa fa-file-text-o",
                "url": "pulmonologyDefinition",
                "auto_crud": true,
                "breadcrumb": "Pulmonology"
            },
            {
                "name": "menu.nuclear_medicine_definition",
                "resource": "nuclearmedicineDefinition",
                "icon": "fa fa-file-text-o",
                "url": "nuclearmedicineDefinition",
                "auto_crud": true,
                "breadcrumb": "NuclearMedicine"
            },
            {
                "name": "menu.observationdefinition",
                "resource": "observationdefinition",
                "icon": "fa fa-file-text-o",
                "url": "observationdefinition",
                "auto_crud": true,
                "breadcrumb": "RIS Definition"
            }
        ]
    },
    {
        "name": "menu.diagnostic_master",
        "icon": "fa fa-plus-square",
        "data": {
            "nav_url": "diagnostic_master"
        },
        "children": [
            {
                "name": "menu.specimen",
                "resource": "vacutainer",
                "icon": "fa fa-file-text-o",
                "url": "vacutainer",
                "auto_crud": true,
                "breadcrumb": "Specimen"
            },
            {
                "name": "menu.panel_constraint",
                "resource": "panel_constraint",
                "icon": "fa fa-file-text-o",
                "url": "panel_constraint",
                "auto_crud": true,
                "breadcrumb": "Panel Constraint"
            },
            {
                "name": "menu.organism",
                "resource": "organism",
                "icon": "fa fa-file-text-o",
                "url": "organism",
                "auto_crud": true,
                "breadcrumb": "Organism"
            },
            {
                "name": "menu.antibiotic",
                "resource": "antibiotic",
                "icon": "fa fa-file-text-o",
                "url": "antibiotic",
                "auto_crud": true,
                "breadcrumb": "Antibiotic"
            },
            {
                "name": "menu.organism_antibiotic_mapping",
                "resource": "organismAntibioticMapping",
                "icon": "fa fa-file-text-o",
                "url": "organismAntibioticMapping",
                "auto_crud": true,
                "breadcrumb": "Organism Antibiotic Mapping"
            },
            {
                "name": "menu.organism_antibiotic_sequencing",
                "resource": "organismAntibioticSequencing",
                "icon": "fa fa-file-text-o",
                "url": "organismAntibioticSequencing",
                "auto_crud": true,
                "breadcrumb": "Organism Antibiotic Sequencing"
            },
            {
                "name": "menu.microbiology_methods",
                "resource": "microbiology_methods",
                "icon": "fa fa-file-text-o",
                "url": "microbiology_methods",
                "auto_crud": true,
                "breadcrumb": "Microbiology Methods"
            },
            {
                "name": "menu.dropdown_result",
                "resource": "dropdownMaster",
                "icon": "fa fa-file-text-o",
                "url": "dropdownMaster",
                "auto_crud": true,
                "breadcrumb": "Dropdown Master"
            },
            {
                "name": "menu.dropdown_value",
                "resource": "dropdownValueMaster",
                "icon": "fa fa-file-text-o",
                "url": "dropdownValueMaster",
                "auto_crud": true,
                "breadcrumb": "Dropdown Value Master"
            },
            {
                "name": "menu.dropdown_result_value_mapping",
                "resource": "dropdownMasterValueMapping",
                "icon": "fa fa-file-text-o",
                "url": "dropdownMasterValueMapping",
                "auto_crud": true,
                "breadcrumb": "Dropdown Master Value Mapping"
            },
            {
                "name": "menu.print_sequence_format",
                "resource": "print_sequence_format",
                "icon": "fa fa-file-text-o",
                "url": "print_sequence_format",
                "auto_crud": true,
                "breadcrumb": "Print Sequence",
                "check_permission": false
            },
            {
                "name": "menu.print_sequence",
                "resource": "print_sequence",
                "icon": "fa fa-file-text-o",
                "url": "print_sequence",
                "auto_crud": true,
                "showMenu":false,
                "permission_required": false,
                "breadcrumb": "Print Sequence",
                "check_permission": true
            },
            {
                "name": "menu.print_sequence",
                "resource": "print_sequence_subdepartment",
                "icon": "fa fa-file-text-o",
                "url": "print_sequence_subdepartment",
                "auto_crud": true,
                "showMenu":false,
                "permission_required": false,
                "breadcrumb": "Print Sequence",
                "check_permission": false
            },
            {
                "name": "menu.heading",
                "resource": "heading",
                "icon": "fa fa-file-text-o",
                "url": "heading",
                "auto_crud": true,
                "breadcrumb": "Heading"
            },
            {
                "name": "menu.labSignature",
                "resource": "labSignature",
                "icon": "fa fa-file-text-o",
                "url": "labSignature",
                "auto_crud": true,
                "breadcrumb": "Doctor Signature",
                "check_permission": false
            },
            {
                "name": "menu.process_stage_configuration_master",
                "resource": "process_stage",
                "icon": "fa fa-file-text-o",
                "url": "process_stage",
                "auto_crud": true,
                "breadcrumb": "Process Stage",
                "check_permission": false
            },
            {
                "name": "menu.tray_code",
                "resource": "tray_code",
                "icon": "fa fa-file-text-o",
                "url": "tray_code",
                "auto_crud": true,
                "permission_required": false,
                "breadcrumb": "Tray Code",
                "check_permission": false
            },
            {
                "name": "menu.smear",
                "resource": "smear",
                "icon": "fa fa-file-text-o",
                "url": "smear",
                "auto_crud": true,
                "breadcrumb": "Smear"
            },
            {
                "name": "menu.separator_master",
                "resource": "separator_master",
                "icon": "fa fa-file-text-o",
                "url": "separator_master",
                "auto_crud": true,
                "breadcrumb": "Separator Master"
            },
        ]
    },
    {
        "name": "menu.worklist",
        "icon": "fa fa-building-o",
        "data": {
            "nav_url": "specimen_format_m"
        },
        "children": [
            {
                "name": "menu.pathology",
                "resource": "specimen_format",
                "icon": "fa fa-file-text-o",
                "url": "specimen_format",
                "auto_crud": true,
                "breadcrumb": "pathology",
                "check_permission": false
            },
            {
                "name": "menu.histopathology",
                "resource": "histopathology_format",
                "icon": "fa fa-file-text-o",
                "url": "histopathology_format",
                "auto_crud": true,
                "breadcrumb": "histopathology",
                "check_permission": false
            },
            {
                "name": "menu.sample_storage",
                "resource": "histo_sample_storage_format",
                "icon": "fa fa-file-text-o",
                "url": "histo_sample_storage_format",
                "auto_crud": true,
                "breadcrumb": "sample_storage",
                "check_permission": false
            },
            {
                "name": "menu.radiology",
                "resource": "radio_format",
                "icon": "fa fa-file-text-o",
                "url": "radio_format",
                "auto_crud": true,
                "breadcrumb": "radiology",
                "check_permission": false
            },
            {
                "name": "menu.pathologyAppointments",
                "resource": "pathology_appointments",
                "icon": "fa fa-file-text-o",
                "url": "pathology_appointments",
                "auto_crud": true,
                "breadcrumb": "radiology",
                "check_permission": false
            },
            {
                "name": "menu.radiologyAppointments",
                "resource": "radiology_appointments",
                "icon": "fa fa-file-text-o",
                "url": "radiology_appointments",
                "auto_crud": true,
                "breadcrumb": "radiology",
                "check_permission": false
            },
            {
                "name": "menu.cardiologyAppointments",
                "resource": "cardiology_appointments",
                "icon": "fa fa-file-text-o",
                "url": "cardiology_appointments",
                "auto_crud": true,
                "breadcrumb": "radiology",
                "check_permission": false
            },
            {
                "name": "menu.pulmonologyAppointments",
                "resource": "pulmonology_appointments",
                "icon": "fa fa-file-text-o",
                "url": "pulmonology_appointments",
                "auto_crud": true,
                "breadcrumb": "radiology",
                "check_permission": false
            },
            {
                "name": "menu.neurologyAppointments",
                "resource": "neurology_appointments",
                "icon": "fa fa-file-text-o",
                "url": "neurology_appointments",
                "auto_crud": true,
                "breadcrumb": "radiology",
                "check_permission": false
            },
            {
                "name": "menu.nuclearMedicineAppointments",
                "resource": "nuclearMedicine_appointments",
                "icon": "fa fa-file-text-o",
                "url": "nuclearMedicine_appointments",
                "auto_crud": true,
                "breadcrumb": "radiology",
                "check_permission": false
            },
            {
                "name": "menu.pulmonology",
                "resource": "pulmonology_format",
                "icon": "fa fa-file-text-o",
                "url": "pulmonology_format",
                "auto_crud": true,
                "breadcrumb": "pulmonology",
                "check_permission": false
            },
            {
                "name": "menu.cardiology",
                "resource": "cardiology_format",
                "icon": "fa fa-file-text-o",
                "url": "cardiology_format",
                "auto_crud": true,
                "breadcrumb": "cardiology",
                "check_permission": false
            },
            {
                "name": "menu.neurology",
                "resource": "neurology_format",
                "icon": "fa fa-file-text-o",
                "url": "neurology_format",
                "auto_crud": true,
                "breadcrumb": "neurology",
                "check_permission": false
            },
            {
                "name": "menu.nuclear_medicine",
                "resource": "nuclear_medicine_format",
                "icon": "fa fa-file-text-o",
                "url": "nuclear_medicine_format",
                "auto_crud": true,
                "breadcrumb": "nuclear_medicine",
                "check_permission": false
            },
            {
                "name": "menu.pathology",
                "resource": "specimen_home_care_outsource",
                "icon": "fa fa-file-text-o",
                "url": "specimen_home_care_outsource",
                "auto_crud": true,
                "breadcrumb": "pathology",
                "check_permission": false
            },
            {
                "name": "menu.pathology",
                "resource": "re_assign_outsource_center",
                "icon": "fa fa-file-text-o",
                "url": "re_assign_outsource_center",
                "auto_crud": true,
                "breadcrumb": "pathology",
                "check_permission": false
            },
            {
                "name": "menu.ris_clinical_services",
                "resource": "ris_clinical_services_format",
                "icon": "fa fa-file-text-o",
                "url": "ris_clinical_services_format",
                "auto_crud": true,
                "breadcrumb": "ris_clinical_services",
                "check_permission": false
            },
            {
                "name": "menu.pathology",
                "resource": "specimen_thaw_sample",
                "icon": "fa fa-file-text-o",
                "url": "specimen_thaw_sample",
                "auto_crud": true,
                "breadcrumb": "pathology",
                "check_permission": false
            }
        ]
    },
    {
        "name": "menu.specimen_upload_result",
        "resource": "specimen_upload_result",
        "icon": "fa fa-file-text-o",
        "url": "specimen_upload_result",
        "showMenu": false,
        "component": "hidden",
        "auto_crud": true,
        "breadcrumb": "Template"
    },
    {
        "name": "menu.vital_definition",
        "resource": "vitalDefinition",
        "icon": "fa fa-user-md",
        "url": "vitalDefinition",
        "auto_crud": true,
        "breadcrumb": "Folder Master",
        "check_permission": false,
        "showMenu": true
    },
    {
        "name": "menu.vital_definition",
        "resource": "system_vital_master",
        "icon": "fa fa-user-md",
        "url": "system_vital_master",
        "auto_crud": true,
        "showMenu": true
    },
    {
        "name": "menu.bulk_upload",
        "resource": "upload",
        "icon": "fa fa-user-md",
        "url": "upload",
        "auto_crud": false,
        "breadcrumb": "Folder Master",
        "check_permission": false,
        "showMenu": true
    },
    {
        "name": "menu.patient_clearence",
        "icon": "fa fa-h-square",
        "url": "patient_clearence",
        "check_permision": false,
        "auto_crud": false,
        "showMenu": false
    },
    {
        "name": "menu.vital_definition",
        "resource": "vitals_master_account",
        "icon": "fa fa-user-md",
        "url": "vitals_master_account",
        "auto_crud": true,
        "showMenu": true
    },
    {
        "name": "menu.workilst_finalized_report",
        "resource": "workilst_finalized_report",
        "icon": "fa fa-user-md",
        "url": "workilst_finalized_report",
        "auto_crud": true,
        "showMenu": true
    },
    {
        "name": "menu.workilst_finalized_report_kiosk",
        "resource": "workilst_finalized_report_kiosk",
        "icon": "fa fa-user-md",
        "url": "workilst_finalized_report_kiosk",
        "auto_crud": true,
        "showMenu": true
    },
    {
        "name": "menu.radio_finalized_report",
        "resource": "radio_finalized_report",
        "icon": "fa fa-user-md",
        "url": "radio_finalized_report",
        "auto_crud": true,
        "showMenu": true
    },
    {
        "name": "menu.radio_finalized_report_kiosk",
        "resource": "radio_finalized_report_kiosk",
        "icon": "fa fa-user-md",
        "url": "radio_finalized_report_kiosk",
        "auto_crud": true,
        "showMenu": true
    }
]